
export default function Dashboard() {

  return (
   <div
      className="d-flex flex-column justify-content-center align-items-center vh-100 bg-gradient"
      style={{ background: 'linear-gradient(135deg, #6f42c1, #4e73df)' }}
    >
      <div className="text-center text-white">
        {/* Título con mejor visibilidad y sombra */}
        <h1
          className="fs-1 fw-bold mb-4"
          style={{
            textShadow: '4px 4px 8px rgba(0, 0, 0, 0.5)', // Más sombra para mejor contraste
            fontSize: '4rem', // Aumentando el tamaño de la fuente
            fontWeight: '700', // Negrita más fuerte
            letterSpacing: '2px', // Espaciado entre letras
          }}
        >
          GP VIGILANCIA
        </h1>
        <div
          className="d-flex justify-content-center align-items-center mb-5"
          style={{
            animation: 'fadeIn 2s ease-in-out',
            fontSize: '2rem', // Aumentando tamaño de la versión
          }}
        >
          <strong
            className="fs-4 text-dark"
            style={{
              fontWeight: '500',
              color: '#f8f9fa', // Blanco con un toque más suave para contrastar
            }}
          >
            v1.0.0
          </strong>
        </div>
        <div className="mt-4">
          <img
            src="/icon-grupo-polo.ico"
            alt="Icono App"
            style={{
              width: '100px', // Aumentando el tamaño del icono
              height: '100px',
              borderRadius: '50%',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', // Añadiendo sombra para el icono
              padding: '10px', // Añadiendo padding para el icono
            }}
          />
        </div>
      </div>
    </div>

  );
}

